var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFolder(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.5 7L12.3845 4.76892C12.0634 4.1268 11.9029 3.80573 11.6634 3.57116C11.4516 3.36373 11.1963 3.20597 10.9161 3.10931C10.5992 3 10.2402 3 9.52229 3H5.7C4.5799 3 4.01984 3 3.59202 3.21799C3.21569 3.40973 2.90973 3.71569 2.71799 4.09202C2.5 4.51984 2.5 5.0799 2.5 6.2V7M2.5 7H17.7C19.3802 7 20.2202 7 20.862 7.32698C21.4265 7.6146 21.8854 8.07354 22.173 8.63803C22.5 9.27976 22.5 10.1198 22.5 11.8V16.2C22.5 17.8802 22.5 18.7202 22.173 19.362C21.8854 19.9265 21.4265 20.3854 20.862 20.673C20.2202 21 19.3802 21 17.7 21H7.3C5.61984 21 4.77976 21 4.13803 20.673C3.57354 20.3854 3.1146 19.9265 2.82698 19.362C2.5 18.7202 2.5 17.8802 2.5 16.2V7Z",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFolder);
export default __webpack_public_path__ + "static/media/folder.f2d596eed726ed01461b1f0b4b360ea0.svg";
export { ForwardRef as ReactComponent };